import React from 'react';
import { Container, Divider } from 'semantic-ui-react';
import Event from './Event';


const EventGroup = (props) => {
  return (
    !!props.data &&
      <Container text>
        <Divider horizontal inverted>
          {props.title}
        </Divider>
        <Divider hidden />
        {props.data.map(e => <Event key={e.id} data={e}/>)}
        <Divider hidden />
      </Container>
  );
};

export default EventGroup;



// WEBPACK FOOTER //
// ./src/public/components/EventsList/EventGroup.js